import { __awaiter } from "tslib";
import { log, sleep } from "../utils";
import { version } from "../version";
export default class MatchmakerApi {
    constructor(configService, httpClient, cognitoTokenCallback = () => "") {
        this.configService = configService;
        this.httpClient = httpClient;
        this.cognitoTokenCallback = cognitoTokenCallback;
    }
    matchmakerApiUrl() {
        return this.configService.config.instanceMatchingUrl + "/api";
    }
    fetchNewSessionToken(clientConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug(`Fetching session token from matchmaker with clientConfig: ${JSON.stringify(clientConfig)}`);
            const url = this.matchmakerApiUrl() + "/token";
            const headers = Object.assign(Object.assign({ "Content-Type": "application/json" }, clientConfig), { version, authorization: yield this.cognitoTokenCallback() });
            const response = yield this.httpClient.get(url, headers);
            // TODO: validate response
            return response.body.token;
        });
    }
    requestAveInstance(clientConfig_1) {
        return __awaiter(this, arguments, void 0, function* (clientConfig, sleepInterval = 2000) {
            log.debug("Requesting rendering instance");
            const url = this.matchmakerApiUrl() + "/getAVEInstance";
            const headers = Object.assign(Object.assign({ "Content-Type": "application/json" }, (clientConfig !== null && clientConfig !== void 0 ? clientConfig : {})), { version, authorization: yield this.cognitoTokenCallback() });
            for (let i = 0; i < 3; i++) {
                try {
                    const response = yield this.httpClient.get(url, headers);
                    const { token, instanceIp, aveVersion } = response.body;
                    log.info(`Got rendering instance=${instanceIp} with aveVersion=${aveVersion}`);
                    return { aveInstanceIp: instanceIp, sessionToken: token };
                }
                catch (error) {
                    log.info("Failed getting render instance. Trying again.");
                }
                yield sleep(sleepInterval);
            }
            throw new Error("Failed getting render instance.");
        });
    }
    checkInstanceAvailability(clientConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug("Checking instance availability");
            const url = this.matchmakerApiUrl() + "/instances";
            const headers = Object.assign(Object.assign({}, clientConfig), { authorization: yield this.cognitoTokenCallback() });
            try {
                const response = yield this.httpClient.get(url, headers);
                return response.body.isAvailable;
            }
            catch (error) {
                log.error("Failed checking the availability of AVE instances, error=", error);
                return false;
            }
        });
    }
    fetchPublicInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug("Fetching matchmaker info");
            const url = this.configService.config.instanceMatchingUrl + "/public/info";
            const headers = {
                authorization: yield this.cognitoTokenCallback(),
            };
            const response = yield this.httpClient.get(url, headers);
            return response.body;
        });
    }
    detectBlockedDomain() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const matchmakerInfo = yield this.fetchPublicInfo();
                log.info("Got matchmaker info=", matchmakerInfo);
            }
            catch (error) {
                log.error("Could not fetch matchmaker info. " +
                    "A possible reason could be that you are using a private network that blocks the streaming service. " +
                    "Please contact your network administrator to unblock the streaming domain '*.avp.tech'");
                throw error;
            }
        });
    }
}
//# sourceMappingURL=matchmaker-api.js.map